import { SupportedCountries } from '../../features/utils/types';

export const useCountryCode = () => {
  if (window.location.href.includes(SupportedCountries.LUXEMBOURG))
    return SupportedCountries.LUXEMBOURG;
  if (window.location.href.includes(SupportedCountries.FRANCE))
    return SupportedCountries.FRANCE;

  // default nothing
  return '';
};
